
import { Options, Vue }    from 'vue-class-component';
import AddonCard from '../components/shared/addon-card.vue'
import ToggleSwitch from '../components/shared/toggle-switch.vue'
import { chain, keyBy, mapValues, uniqBy } from 'lodash'

@Options({
  components: {
    AddonCard,
    ToggleSwitch
  },
  data() {
    return {
      items: this.$store.state.grouts,
      premium: (this.$store.state.grouts || []).filter(x => x.attributes.vrsta_fugirne_mase === 'Premium'),
      klasicne: (this.$store.state.grouts || []).filter(x => x.attributes.vrsta_fugirne_mase === 'Klasična'),
      title: {
        left: this.$t('Premium'),
        right: this.$t('Klasične')
      },
      isChecked: this.$store.state.groutSlider
    }
  },
  methods: {
    switched(value){
      this.isChecked = value;
      this.$store.commit('setGroutSlider',value)
    }
  },
  watch: {
    premium:{
      handler:function(newVal) {
        let grouts = (this.$store.state.grouts || []).concat(newVal)
        this.$store.commit('setGrouts', uniqBy(grouts,'key'));
      },
      deep:true
    },
    klasicne:{
      handler:function(newVal) {
        let grouts = (this.$store.state.grouts || []).concat(newVal)
        this.$store.commit('setGrouts', uniqBy(grouts,'key'));
      },
      deep:true
    }
  }
})
export default class Grout extends Vue {
  items: { key: string; title: string; attributes: ({ key: string; value: string; } | { key: string; value: number; })[]; price: string; media: any; }[];
  premium: { key: string; title: string; attributes: ({ key: string; value: string; } | { key: string; value: number; })[]; price: string; media: any; }[];
  klasicne: { key: string; title: string; attributes: ({ key: string; value: string; } | { key: string; value: number; })[]; price: string; media: any; }[];
  isChecked: boolean;
  mounted(){
    const productRes = this.$store.state.grouts || this.$store.state.responseGrouts.map(x=> ({
      id: x._id,
      key: x.key,
      title: x.name,
      description: x.description,
      attributes: chain(x.propertyAttributes).keyBy('key').mapValues('value').value(),
      price: x.priceUnit ? `${(x.estimatedPrice.retailPriceWithDiscount || x.estimatedPrice.retailPrice).toFixed(2)} € / ${x.priceUnit}` : `${(x.estimatedPrice.retailPriceWithDiscount || x.estimatedPrice.retailPrice).toFixed(2)} €`,
      priceWithoutDiscount: x.priceUnit ? `${x.estimatedPrice.retailPrice.toFixed(2)} € / ${x.priceUnit}` : `${x.estimatedPrice.retailPrice.toFixed(2)} €`,
      discount: x.estimatedPrice.retailPriceDiscount?.value > 0 ? true : false,
      thumbnail: x.metadata.thumbnail,
      priceUnit: x.priceUnit
    }));

    this.items = productRes;
    this.premium = productRes.filter(x => x.attributes.vrsta_fugirne_mase === 'Premium');
    this.klasicne = productRes.filter(x => x.attributes.vrsta_fugirne_mase === 'Klasična');
  }
}
